const dealersData = {
  dealers: [
    { label: 'OPEL Tauranga', code: 'OTAUR' },
    { label: 'OPEL North Shore', code: 'ONSHR' },
    { label: 'OPEL Hawkes Bay - Ebbetts', code: 'OHWKB' },
    { label: "OPEL East Auckland - Armstrong's", code: 'OEAST' },
    { label: "OPEL Auckland - Armstrong's", code: 'OGNLN' },
    { label: "OPEL Christchurch - Armstrong's", code: 'OCHCH' },
    { label: "OPEL Wellington - Armstrong's ", code: 'OWGTN' },
    { label: 'OPEL Hamilton - Ebbetts', code: 'OHMTN' }
  ]
}

export default dealersData
